











































import { Vue } from 'vue-property-decorator';
import Component from 'vue-class-component';
import { State, Action, Getter } from 'vuex-class';

const namespace: string = 'authentication';

@Component
export default class LoginView extends Vue {
    @Action('login', { namespace }) login: any;
    @Getter('error', { namespace }) getError!: boolean;

    loginForm: any = {
        email: '',
        password: '',
    };

    get error() {
        return this.getError;
    }

    onSubmit() {
        this.login(this.loginForm);
    }
}
